import { DateType } from "@date-io/type";
import { Gender, ILegalEntity, ILocation, InvoiceType } from "../../types";

export const substitutionReasonValue = {
    GUASTO: 'GUASTO',
    TARGA_SMARRITA: 'TARGA_SMARRITA',
    INCIDENTE_SENZA_CONTROPARTE: 'INCIDENTE_SENZA_CONTROPARTE',
    INCIDENTE_CON_CONTROPARTE: 'INCIDENTE_CON_CONTROPARTE',
    INCENDIO: 'INCENDIO',
    FURTO_VEICOLO: 'FURTO_VEICOLO',
    FURTO_PARZIALE: 'FURTO_PARZIALE',
    REMARKETING: 'REMARKETING',
    CAMBIO_TARGA: 'CAMBIO_TARGA'
}

export interface AccordionsExpanded {
    eventInfo: boolean,
    assets: boolean,
    carToReplace: boolean,
    replacementCar: boolean
}

export interface IFormValues {
    originRaData: {
        pickupDate: DateType | undefined,
        dropoffDate: DateType | undefined,
        dropoffLocation: ILocation | null
    },
    eventInfo: {
        reason: string,
        eventDate:  DateType | null,
        eventPlaceGoogleAddress: string,
        eventPlaceCountry: string,
        eventPlaceProvince: string,
        eventPlaceCity: string,
        eventPlacePostalCode: string,
        eventPlaceStreetName: string,
        eventPlaceStreetNumber: string,
        eventDescription: string,
        vehicleAvailability: boolean,
        policeInvolved: boolean,
        notePoliceInvolved: string
        substancesInfluence: boolean
    },
    assets: {
        caiModuloDenuncia: File | null,
        denunciaFurtoSmarrimento: File | null
        ricevutaCarroattrezzi: File | null
    },
    carToReplace: {
        dropoffLocation: ILocation | null,
        dropoffDate: DateType | null,
    },
    replacementCar: {
        pickupLocation: ILocation | null,
        pickupDate: DateType | null,
        dropoffLocation: string,
        dropoffDate: DateType | null,
        vehicleType: string,
        carGroup: string,
        ancillaries: string[],
        excDamage: number,
        excFireTheft: number,
        mileageIncluded: string,
        ekm: string
    },
    firstDriver: {
        id: string,
        firstName: string,
        lastName: string,
        birthDate: string,
        birthNation: string,
        birthPlace: string,
        residenceCountry: string,
        fiscalCode: string,
        drivingLicenseNumber: string,
        email: string,
        mobile: string,
        mobilePrefix: string,
        webCheckIn: string,
        gender: Gender | ''
    },
    bookingOwner: {
        id: string,
        firstName: string,
        lastName: string,
        birthDate: string,
        birthNation: string,
        birthPlace: string,
        residenceCountry: string,
        fiscalCode: string,
        drivingLicenseNumber: string,
        email: string,
        mobile: string,
        mobilePrefix: string,
        companyName: string,
        country: string,
        city: string,
        streetName: string,
        streetNumber: string,
        postalCode: string
        certifiedEmailAddress: string,
        telephone: string,
        vatNumber: string,
        vatNumberCountry: string,
        sdiCode: string,
        legalEntity: ILegalEntity | null
    },
    billingOwner: {
        id: string,
        type: InvoiceType | '',
        firstName: string,
        lastName: string,
        birthDate: string,
        birthNation: string,
        birthPlace: string,
        residenceCountry: string,
        fiscalCode: string,
        drivingLicenseNumber: string,
        email: string,
        mobile: string,
        mobilePrefix: string,
        billingCountry: string,
        billingProvince: string,
        billingCity: string,
        billingStreetName: string,
        billingStreetNumber: string,
        billingPostalCode: string,
        certifiedEmailAddress: string,
        vatNumber: string,
        vatNumberCountry: string,
        invoiceCode: string,
        companyName: string,
        legalEntity: ILegalEntity | null
    },
    additionalDriver: {
        id: string,
        firstName: string,
        lastName: string,
        email: string,
        webCheckIn: string
    }[]
}

export const MAX_CHAR_TEXTAREA: number = 1000;
